'use strict';
const initModals = () => {
    function setCookie(cookieName, cookieValue, expireDays) {
        const date = new Date();
        date.setTime(date.getTime() + (expireDays*24*60*60*1000));
        const expires = "expires="+ date.toUTCString();
        document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/";
    }

    function getCookie(cookieName) {
        const name = cookieName + "=";
        const decodedCookie = decodeURIComponent(document.cookie);
        const cookieArray = decodedCookie.split(';');

        for(let i = 0; i < cookieArray.length; i++) {
            let cookie = cookieArray[i];
            while (cookie.charAt(0) === ' ') {
                cookie = cookie.substring(1);
            }
            if (cookie.indexOf(name) === 0) {
                return cookie.substring(name.length, cookie.length);
            }
        }
        return "";
    }

    jQuery(document).on("click", ".js-modal.js-modal-close, .js-modal .js-modal-close", function (event) {
        if (jQuery(event.target).hasClass('js-modal-close')) {
            document.querySelector('#' + jQuery(this).data('modal-id')).close();
        }
    });

    jQuery(document).on("click", ".js-open-modal", function () {
        document.querySelector('#' + jQuery(this).data('modal-id')).showModal();
    });

    document.querySelectorAll('.js-modal-cookiecontrolled').forEach(modal => {
            const id = jQuery(modal).attr('id');
            if (!getCookie(id)) {
               /* setTimeout(function () {
                    modal.showModal();
                }, 2000);

                */
            }
        }
    );

    jQuery(document).on("click", ".js-modal-cookiecontrolled.js-modal-close, .js-modal-cookiecontrolled .js-modal-close", function (event) {
        if (jQuery(event.target).hasClass('js-modal-close')) {
            const id = jQuery(this).data('modal-id');
            const modal = document.querySelector('#' + id);
            modal.close();
            setCookie(id);
        }
    });

    jQuery(document).on("click", "dialog", function (event) {
        if (event.target === this) {
            event.target.close();
        }
    });
};

module.exports = initModals;
